export default "/images/plus-square.svg?f96dbb70f302610139d66a6212b2e630";